import React, { lazy } from 'react'
import { Route } from 'react-router'
import { SubRouter } from '@/router/SubRouter'

const StockScanIndex = lazy(() => import('./stock/:code/Index'))

// Liens universels de l'app crew (QR des étiquettes) : repli web quand l'app n'est pas installée.
export const CrewRouter = React.memo(() => (
  <SubRouter loggedIn>
    <Route path='stock/:code' element={<StockScanIndex />} />
  </SubRouter>
))
